var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import ExcelJS from 'exceljs';
import { Tooltip } from 'antd';
import { FileExcelOutlined } from '@ant-design/icons';
import { searchCertificates } from '../../services/certificateService';
import commonService from "../../services/CommonService";
import { UserActivity } from "../../config/BVConstants";
import { useSelector } from "react-redux";
const CertificateExcelDownload = ({ filename, searchCertRequest }) => {
    let data = [];
    const [loading, setLoading] = useState(false);
    const applicationData = useSelector((state) => state.applicationData);
    const downloadExcel = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        setLoading(true);
        searchCertRequest.intFirstPage = null;
        searchCertRequest.intPageSize = null;
        data = yield searchCertificates(searchCertRequest);
        setLoading(false);
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Results');
        worksheet.columns = [
            { header: 'Entity Name', key: 'entityName', width: 25 },
            { header: 'Brand/OEM', key: 'brandOem', width: 25 },
            { header: 'Product Model(Series Model)', key: 'productModel', width: 30 },
            { header: 'Product', key: 'product', width: 30 },
            { header: 'Service Type', key: 'serviceType', width: 25 },
            { header: 'Country/Territory', key: 'country', width: 25 },
            { header: 'Certificate Name', key: 'certificateName', width: 30 },
            { header: 'Factory/Importer/OEM', key: 'factory', width: 30 },
            { header: 'Certificate ID', key: 'certificateId', width: 25 },
            { header: 'Certificate Issue Date', key: 'issueDate', width: 25 },
            { header: 'Certificate Expiration Date', key: 'expirationDate', width: 25 },
            { header: 'Certificate Status', key: 'certificateStatus', width: 25 },
            { header: 'Recommended Decision Date', key: 'decisionDate', width: 25 },
            { header: 'Recommended Requested Date', key: 'requestedDate', width: 25 },
            { header: 'Renewal Status', key: 'renewalStatus', width: 25 },
            { header: 'New Certificate ID', key: 'newCertificateId', width: 25 },
            { header: 'Lab', key: 'lab', width: 25 },
            { header: 'Certificate Holder', key: 'certificateHolder', width: 25 },
            { header: 'BV Location', key: 'bvLocation', width: 25 }
        ];
        // Add rows
        if (Array.isArray(data)) {
            worksheet.addRows(data.map(item => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
                return ({
                    entityName: ((_a = item.objLuCompany) === null || _a === void 0 ? void 0 : _a.strLongDesc) || "",
                    brandOem: ((_b = item.objBrandName) === null || _b === void 0 ? void 0 : _b.strLongDesc) || "",
                    productModel: item.strModelName || "",
                    product: `${((_d = (_c = item.objTblService) === null || _c === void 0 ? void 0 : _c.objLuProductMainType) === null || _d === void 0 ? void 0 : _d.strLongDesc) || ""}/${((_f = (_e = item.objTblService) === null || _e === void 0 ? void 0 : _e.objLuProductType) === null || _f === void 0 ? void 0 : _f.strLongDesc) || ""}`,
                    serviceType: ((_h = (_g = item.objTblService) === null || _g === void 0 ? void 0 : _g.objLuServiceCode) === null || _h === void 0 ? void 0 : _h.strLongDesc) || "",
                    country: ((_j = item.objLuCountry) === null || _j === void 0 ? void 0 : _j.strLongDesc) || "",
                    certificateName: item.strServiceName || "",
                    factory: ((_k = item.objEEMaster) === null || _k === void 0 ? void 0 : _k.strFactoryName) || "",
                    certificateId: item.strCertId || "",
                    issueDate: item.strdtCertDate || "",
                    expirationDate: item.strdtCertExpDate || "",
                    certificateStatus: ((_l = item.objCertStatus) === null || _l === void 0 ? void 0 : _l.strLongDesc) || "",
                    decisionDate: item.strdtRenewalDate || "",
                    requestedDate: item.strdtRenewalDate || "",
                    renewalStatus: ((_m = item.objCertRenewalStatus) === null || _m === void 0 ? void 0 : _m.strLongDesc) || "",
                    newCertificateId: item.strNewCertificateId || "",
                    lab: item.strLab || "",
                    certificateHolder: item.strCertificateHolder || "",
                    bvLocation: ((_o = item.objBusinessunit) === null || _o === void 0 ? void 0 : _o.strBusinessUnitName) || ""
                });
            }));
        }
        commonService
            .logUserActivity((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId, UserActivity.CP__Cert_Report_Download);
        worksheet.getRow(1).font = { bold: true };
        worksheet.getRow(1).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'D3D3D3' }
        };
        worksheet.getRow(1).alignment = { horizontal: 'center' };
        worksheet.columns.forEach(col => {
            col.width = col.width || 20;
        });
        const buffer = yield workbook.xlsx.writeBuffer();
        const url = window.URL.createObjectURL(new Blob([buffer]));
        const a = document.createElement('a');
        a.href = url;
        a.download = `${filename}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
    });
    return (_jsx(Tooltip, { color: "#00A4A4", title: 'Download Excel', children: _jsx(FileExcelOutlined, { style: { fontSize: '20px', color: 'green' }, onClick: downloadExcel, spin: loading }) }));
};
export default CertificateExcelDownload;
